// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"cd33e3df","848":"a4231f8b"}[chunkId] + ".chunk.js";
};